import * as React from 'react';
import LoadingWithMessage from '../../../misc/components/LoadingWithMessage';
import { DevicesAction, MailConfirmedAction, SetInteractionModalStepAction, SetUploadStatusAction } from '../../DevicesNewReducer';
import { FailedToMarkAsMailedMessage } from '../../../misc/api/DeviceLinkApi/GenericMessages';
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

export interface MailConfirmationProps {
    mailAddress: string;
    isFetchingAddress: boolean;
    selectedSessionIds: Array<string>;
    dispatch: React.Dispatch<DevicesAction>;
}

export interface MailConfirmationState {
    trackingNumber: string;
}

export const MailConfirmation = (props: MailConfirmationProps) => {
    const [trackingNumber, setTrackingNumber] = React.useState('');
    const legacyClient = useWebPortalLegacyClient();

    const ConfirmMailIn = async () => {
        for (const sessionId of props.selectedSessionIds) {
            const result = await legacyClient.confirmMailing(sessionId, trackingNumber);
            if (result.Id) {
                props.dispatch(MailConfirmedAction.create(trackingNumber));
            } else {
                props.dispatch(SetUploadStatusAction.create(FailedToMarkAsMailedMessage));
                props.dispatch(SetInteractionModalStepAction.create(5));
            }
        }
    }

    const handleChange = (event) => {
        setTrackingNumber(event.target.value);
    }

    const next = async () => {
        await ConfirmMailIn();
    }

    const back = () => {
        props.dispatch(SetInteractionModalStepAction.create(2));
    }

    const renderModalContent = () => {
        if (!props.mailAddress) {
            return <LoadingWithMessage message="Loading Mail Address..." />;
        } else {
            const addressLines = props.mailAddress.split("<br />").map((item) => <span key={item}>{item}<br /></span>);

            return (
                <>
                    <h2 className="text-primary">Mail Confirmation</h2>
                    <div>
                        <p>Securely pack the data card into an envelope and send to the below address</p>
                        <address className="well">
                            <b>{addressLines}</b>
                        </address>
                        <p>If you have the tracking number for delivery please input it</p>
                        <input className="form-control" placeholder="Tracking number..." type="text" value={trackingNumber} onChange={handleChange} />
                    </div>
                </>
            );
        }
    }

    return (
        <div id="DeviceReturnFailure">
            <div className="modal-header bg-primary">
                <h3 className="modal-title">Manage Device</h3>
            </div>
            <div className="modal-body">
                {renderModalContent()}
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" disabled={props.isFetchingAddress} onClick={next}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={back}>Back</button>
            </div>
        </div>
    );
}

//function mapStateToProps(state: MainState): MailConfirmationProps {
//    return {
//        isFetchingAddress: state.connectedDevices.mail.isFetchingAddress,
//        mailAddress: state.connectedDevices.mail.mailAddress,
//    };
//}
